import type { AuthUser, DrawEvent } from '../types';
import { bus } from '../events';
import { getState } from '../store/store';
import { ApiError, get, post, setUnauthorizedHandler, tokenStore } from '../api/http';

/**
 * Sessão do painel, vinda da API: token JWT no localStorage e usuário carregado por /auth/me.
 * Quem entra decide o que vê: ADMIN e SUPPORT vão ao backoffice, HOST ao painel do anfitrião.
 */
let user: AuthUser | null = null;

export const currentUser = (): AuthUser | null => user;
export const isAdmin   = (): boolean => user?.role === 'ADMIN';
export const isHost    = (): boolean => user?.role === 'HOST';
export const isSupport = (): boolean => user?.role === 'SUPPORT';

/** Ao abrir o painel: com token salvo, pergunta à API quem é. Token inválido é descartado. */
export async function restoreSession(): Promise<void> {
  if (!tokenStore.get()) { user = null; return; }
  try {
    user = await get<AuthUser>('/auth/me');
  } catch (e) {
    if (e instanceof ApiError && e.status !== 0) tokenStore.clear();
    user = null;
  }
}

export async function login(email: string, password: string): Promise<AuthUser> {
  const res = await post<{ token: string; user: AuthUser }>('/auth/login', { email, password });
  tokenStore.set(res.token);
  user = res.user;
  bus.emit('session');
  return user;
}

export function logout(): void {
  tokenStore.clear();
  user = null;
  bus.emit('session');
}

/** Chamado quando a API responde 401 no meio do uso: a sessão acabou. */
export function expireSession(): void {
  if (user) logout();
}
setUnauthorizedHandler(expireSession);

/**
 * Sorteio em foco. Para o anfitrião é o sorteio atribuído na API (quando existir no
 * estado local); para o admin, o sorteio ativo no estúdio.
 */
export function currentEvent(): DrawEvent | null {
  const s = getState();
  if (user?.role === 'HOST') return s.events.find(e => e.id === user!.eventId) ?? null;
  return s.events.find(e => e.id === s.ui.activeEventId) ?? s.events[0] ?? null;
}
